import Vue from 'vue'
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import {
  ADD_WHITELIST_WALLET, DELETE_WHITELIST_WALLET,
  LOAD_SETTINGS,
  UPDATE_SETTING,
} from "../const/settings";
import config from '@/store/config';

export default {
  namespaced: true,
  state: {
    rowColors: [
      '#ffe6d7',
      '#ddffdf',
      '#d7e8ff',
      '#ffd3f8',
      '#c2f3ed',
      '#f3c2c7',
      '#e2e2c8',
      '#f8e2db',
      '#e6ddf3',
      '#b3bbb4',
    ],
    defaults: {
      roles: {
        superadmin: 'Суперадмин',
        admin: 'Админ',
        support: 'Поддержка',
        service: 'Служебный',
        client: 'Клиент',
      },
    },
    cryptoType: config.cryptoType,
  },
  getters: {
    roles: state => state.defaults.roles,
    cryptoType: state => state.cryptoType,
  },
  actions: {
    [LOAD_SETTINGS]: async ({ dispatch }) => {
      return await dispatch(HTTP_GET, {
        method: LOAD_SETTINGS,
        namespace: 'settings',
        no_commit: true,
      }, { root: true });
    },
    [UPDATE_SETTING]: async ({ dispatch }, { name, data }) => {
      return await dispatch(HTTP_PUT, {
        method: UPDATE_SETTING,
        namespace: 'settings',
        no_commit: true,
        replace: { name },
        body: data,
      }, { root: true });
    },
    [ADD_WHITELIST_WALLET]: async ({ dispatch }, { address, token_2fa }) => {
      return await dispatch(HTTP_POST, {
        method: ADD_WHITELIST_WALLET,
        namespace: 'settings',
        no_commit: true,
        body: { address, token_2fa },
      }, { root: true });
    },
    [DELETE_WHITELIST_WALLET]: async ({ dispatch }, address) => {
      return await dispatch(HTTP_DELETE, {
        method: DELETE_WHITELIST_WALLET,
        namespace: 'settings',
        no_commit: true,
        body: { address },
      }, { root: true });
    },
  },
  mutations: {
    [LOAD_SETTINGS]: (state, { data }) => {
      for (const settingName of Object.keys(data)) {
        Vue.set(state, settingName, data[settingName]);
      }
    },
  },
};
